var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account"},[_c('div',{class:['content', {'align-center':_vm.$isPc}, 'justify-between']},[(_vm.$isPc)?_c('el-image',{staticClass:"account-img mr-20 flex-1",attrs:{"src":require('@/assets/images/account-img1.png'),"fit":"contain"}}):_vm._e(),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }